(() => {
  "use strict";

  if (window.mbDescriptionGalleryLoaded) return;
  window.mbDescriptionGalleryLoaded = true;

  const linkSelector =
    ".mb-description .mb-demo-gallery__link, " +
    ".mb-description .mb-description__visual-link";

  let dialog;
  let previewImage;
  let previewCaption;
  let closeButton;
  let previousButton;
  let nextButton;

  let currentLinks = [];
  let currentIndex = 0;
  let opener = null;

  function prepareDescriptions() {
    document
      .querySelectorAll(".mb-description .mb-demo-gallery")
      .forEach((gallery) => {
        const grid = gallery.querySelector(".mb-demo-gallery__grid");
        const extra = gallery.querySelector(".mb-demo-gallery__extra");

        if (!grid) return;

        /* Sei fotografie nella griglia iniziale. */
        while (grid.children.length < 6 && extra?.firstElementChild) {
          grid.append(extra.firstElementChild);
        }

        gallery
          .querySelectorAll(".mb-demo-gallery__item--featured")
          .forEach((item) => {
            item.classList.remove("mb-demo-gallery__item--featured");
          });

        gallery.querySelector(".mb-demo-gallery__count")?.remove();

        const closedLabel = gallery.querySelector(
          ".mb-demo-gallery__label-closed"
        );

        if (closedLabel) {
          closedLabel.textContent = "Descoperiți mai multe fotografii";
        }

        const more = gallery.querySelector(".mb-demo-gallery__more");

        if (more && (!extra || !extra.children.length)) {
          more.remove();
        }

        gallery.classList.add("mb-demo-gallery--uniform");
      });

    document.querySelectorAll(linkSelector).forEach((link) => {
      link.removeAttribute("target");
      link.removeAttribute("rel");

      const alt = link.querySelector("img")?.alt || "Fotografie Rotowash";

      link.setAttribute("aria-label", `Măriți fotografia: ${alt}`);
      link.setAttribute("aria-haspopup", "dialog");
    });
  }

  function showImage(index) {
    currentIndex =
      (index + currentLinks.length) % currentLinks.length;

    const link = currentLinks[currentIndex];
    const originalImage = link.querySelector("img");

    const caption =
      link.closest("figure")?.querySelector("figcaption")
        ?.textContent.trim() ||
      originalImage?.alt ||
      "Rotowash";

    previewImage.alt = originalImage?.alt || caption;
    previewImage.src = link.href;
    previewCaption.textContent = caption;

    previousButton.disabled = currentLinks.length < 2;
    nextButton.disabled = currentLinks.length < 2;
  }

  function createPreview() {
    if (dialog) return;

    dialog = document.createElement("dialog");
    dialog.className = "mb-photo-preview";
    dialog.setAttribute("aria-label", "Previzualizare fotografii Rotowash");
    dialog.setAttribute("lang", "ro");

    dialog.innerHTML = `
      <div class="mb-photo-preview__toolbar">
        <p class="mb-photo-preview__title">Rotowash în detaliu</p>

        <button
          class="mb-photo-preview__control"
          type="button"
          data-mb-close
          aria-label="Închideți previzualizarea"
          autofocus
        >×</button>
      </div>

      <div class="mb-photo-preview__stage">
        <img class="mb-photo-preview__image" alt="">
      </div>

      <div class="mb-photo-preview__footer">
        <button
          class="mb-photo-preview__control"
          type="button"
          data-mb-previous
          aria-label="Fotografia anterioară"
        >←</button>

        <p
          class="mb-photo-preview__caption"
          aria-live="polite"
          aria-atomic="true"
        ></p>

        <button
          class="mb-photo-preview__control"
          type="button"
          data-mb-next
          aria-label="Fotografia următoare"
        >→</button>
      </div>
    `;

    document.body.append(dialog);

    previewImage = dialog.querySelector(".mb-photo-preview__image");
    previewCaption = dialog.querySelector(".mb-photo-preview__caption");

    closeButton = dialog.querySelector("[data-mb-close]");
    previousButton = dialog.querySelector("[data-mb-previous]");
    nextButton = dialog.querySelector("[data-mb-next]");

    closeButton.addEventListener("click", () => dialog.close());

    previousButton.addEventListener("click", () => {
      showImage(currentIndex - 1);
    });

    nextButton.addEventListener("click", () => {
      showImage(currentIndex + 1);
    });

    dialog.addEventListener("keydown", (event) => {
      if (event.key === "ArrowLeft") {
        event.preventDefault();
        event.stopPropagation();
        showImage(currentIndex - 1);
      }

      if (event.key === "ArrowRight") {
        event.preventDefault();
        event.stopPropagation();
        showImage(currentIndex + 1);
      }
    });

    /* Chiusura cliccando sullo sfondo esterno. */
    dialog.addEventListener("click", (event) => {
      if (event.target !== dialog) return;

      const bounds = dialog.getBoundingClientRect();

      if (
        event.clientX < bounds.left ||
        event.clientX > bounds.right ||
        event.clientY < bounds.top ||
        event.clientY > bounds.bottom
      ) {
        dialog.close();
      }
    });

    /* Escape è gestito nativamente dal dialog. */
    dialog.addEventListener("close", () => {
      document.documentElement.classList.remove("mb-photo-preview-open");

      previewImage.removeAttribute("src");

      if (opener?.isConnected) {
        opener.focus({ preventScroll: true });
      }

      currentLinks = [];
      opener = null;
    });
  }

  document.addEventListener(
    "click",
    (event) => {
      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.ctrlKey ||
        event.metaKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      if (!(event.target instanceof Element)) return;

      const link = event.target.closest(linkSelector);
      if (!link) return;

      if (
        typeof HTMLDialogElement === "undefined" ||
        !HTMLDialogElement.prototype.showModal
      ) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      createPreview();

      const gallery = link.closest(".mb-demo-gallery");
      const description = link.closest(".mb-description");

      /* La galleria scorre tutte le dieci fotografie.
         Le immagini editoriali costituiscono un gruppo separato. */
      currentLinks = Array.from(
        gallery
          ? gallery.querySelectorAll(".mb-demo-gallery__link")
          : description.querySelectorAll(".mb-description__visual-link")
      );

      opener = link;
      showImage(currentLinks.indexOf(link));

      dialog.showModal();
      document.documentElement.classList.add("mb-photo-preview-open");
      closeButton.focus({ preventScroll: true });
    },
    true
  );

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      prepareDescriptions,
      { once: true }
    );
  } else {
    prepareDescriptions();
  }

  /* Compatibilità con il ricaricamento delle sezioni nell'editor Shopify. */
  document.addEventListener("shopify:section:load", prepareDescriptions);
})();